import { render, staticRenderFns } from "./set-password.vue?vue&type=template&id=79bc7b6c"
import script from "./set-password.vue?vue&type=script&lang=js"
export * from "./set-password.vue?vue&type=script&lang=js"
import style0 from "./set-password.vue?vue&type=style&index=0&id=79bc7b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports